import {ActionIcon, Box, Divider, Group, Stack, Tooltip} from "@mantine/core";
import ChatThreads from "./chat-threads/ChatThreads";
import IconEdit from "../../../assets/edit.svg?react";
import IconSidebar from "../../../assets/sidebar.svg?react";
import {useGoHome} from "../hooks";
import {useCallback, useContext} from "react";
import {useMediaQuery} from "@mantine/hooks";
import {useTranslation} from "react-i18next";
import IconSettings from "../../../assets/settings.svg?react";
import IconSearch from "../../../assets/search.svg?react";
import {Link} from "react-router-dom";
import classes from "./Navbar.module.css";
import {spotlight} from "@mantine/spotlight";
import IconLogout from "../../../assets/logout.svg?react";
import {AppContext} from "../AppContext";
import {AppSpotlight} from "../AppSpotlight";
import {NavbarItem} from "./NavbarItem";
import {KaiLogo} from "./KaiLogo";

const Navbar: React.FC = () => {
    const {navbarExpanded, toggleNavBar} = useContext(AppContext);
    const [startNewChat] = useGoHome();
    const isDesktop = useMediaQuery("(min-width: 48rem)");
    const {t} = useTranslation();
    const handleNewChat = useCallback(() => {
        startNewChat();
        if (!isDesktop) {
            toggleNavBar();
        }
    }, [startNewChat, toggleNavBar, isDesktop]);

    return (
        <Stack
            h="100%"
            gap="0"
            className={classes.navbar}
            data-expanded={navbarExpanded}
        >
            {/* Top section: Logo, Toggle, Actions */}
            <Box className={classes.topSection}>
                <Stack
                    gap="lg"
                    px="xs"
                    pt={0}
                    pb="md"
                    align={!navbarExpanded ? "center" : "flex-start"}
                >
                    <Group
                        className={classes.logoNav}
                        justify={navbarExpanded ? "space-between" : "center"}
                    >
                        <Link to="/" className={classes.link}>
                            <KaiLogo />
                        </Link>
                        {navbarExpanded && (
                            <Tooltip
                                label={
                                    isDesktop
                                        ? t("common.collapseSidebar")
                                        : t("common.closeSidebar")
                                }
                            >
                                <ActionIcon
                                    variant="subtle"
                                    color="white"
                                    onClick={toggleNavBar}
                                >
                                    <IconSidebar width={20} />
                                </ActionIcon>
                            </Tooltip>
                        )}
                    </Group>
                    {/*                     <Stack
                        gap="xs"
                        pt="lg"
                        w="100%"
                        align={!navbarExpanded ? "center" : "flex-start"}
                    >
                        <NavbarItem
                            icon={<IconEdit width={20} />}
                            label={t("common.newChat")}
                            onClick={handleNewChat}
                            expanded={navbarExpanded}
                        />
                        <NavbarItem
                            icon={<IconSearch width={20} />}
                            label={t("common.search")}
                            onClick={() => spotlight.open()}
                            expanded={navbarExpanded}
                        />
                    </Stack>
 */}
                </Stack>
            </Box>

            {/* <Divider my="xs" color="rgba(255,255,255,0.1)" /> */}

            {/* Chat threads - only shown when expanded */}
            {navbarExpanded && <ChatThreads toggleNavBar={toggleNavBar} />}

            {/* Bottom section */}
            <Box className={classes.bottomSection}>
                <Divider color="rgba(255,255,255,0.1)" />
                <Stack gap="sm" px="xs" py="md">
                    <Link
                        to="/settings"
                        className={classes.link}
                        aria-label={t("settings.title")}
                    >
                        <NavbarItem
                            icon={<IconSettings width={20} />}
                            label={t("settings.title")}
                            expanded={navbarExpanded}
                        />
                    </Link>
                    <a
                        href="/auth/logout"
                        className={classes.link}
                        aria-label={t("settings.logout")}
                    >
                        <NavbarItem
                            icon={<IconLogout width={20} />}
                            label={t("settings.logout")}
                            onClick={() => {}}
                            expanded={navbarExpanded}
                        />
                    </a>
                </Stack>
            </Box>
            <AppSpotlight />
        </Stack>
    );
};

export default Navbar;
